angular.module('flatasticApp')

.filter('newLineToBr', function () {
  return function (text) {
      return text.split("\n").join("<br>");
  };
});
